import { HashLocationStrategy, LocationStrategy, CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { LocalStorageModule } from 'angular-2-local-storage';
import { AngularFireAuthProvider } from 'angularfire2/auth';
import { AngularFireDatabaseProvider } from 'angularfire2/database';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ModalModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AlertModule } from 'ngx-bootstrap';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { LoadingModule } from 'ngx-loading';
import { RlTagInputModule } from 'angular2-tag-input';
import { BootstrapModalModule } from 'ngx-bootstrap-modal';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';

import { AppComponent } from './app.component';
import { FilterPipe, KeysPipe } from './filter.pipe';
import {TimeAgoPipe} from 'time-ago-pipe';


import { FullLayoutComponent } from './layouts/full-layout.component';
import { MdSelectDataModule } from './modules/datamodel/mdselect.module';
import { LoginComponent } from './modules/login/login.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { SignupComponent } from './modules/signup/signup.component';
import { SuperadminModule } from './modules/superadmin/superadmin.module';
import { ProvidersComponent } from './providers/providers.component';
import { StateService } from './services/state/state.service';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { UploadFormComponent } from './uploads/upload-form/upload-form.component';
import { UploadService } from './uploads/shared/upload.service';
import { LocationService } from './services/locations/location.service';
import { ToggleService } from './services/toggle/toggle.service';
import { HttpHandler } from '@angular/common/http/src/backend';
import { SidebarComponent } from './modules/sidebar/sidebar.component';
import { HeaderComponent } from './modules/header/header.component';
import { FooterComponent } from './modules/footer/footer.component';
import { RegisterComponent } from './modules/register/register.component';
import { DoctorsComponent } from './modules/doctors/doctors.component';
import { NotificationsComponent } from './modules/notifications/notifications.component';
import { AddDoctorComponent } from './modules/doctors/add-doctor/add-doctor.component';
import { SchedulesComponent } from './modules/schedules/schedules.component';
import { AddScheduleComponent } from './modules/schedules/add-schedule/add-schedule.component';
import { EditScheduleComponent } from './modules/schedules/edit-schedule/edit-schedule.component';
import { DoctorProfileComponent } from './modules/doctors/doctor-profile/doctor-profile.component';
import { ScheduleComponent } from './modules/schedules/schedule/schedule.component';
import { CalendarModule } from './modules/calendar/calendar.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollableDirective } from './directives/scrollable.directive';
import { InvitationsComponent } from './modules/invitations/invitations.component';
import { SettingComponent } from './modules/setting/setting.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AngularMaterialModule } from './app.material-module';
// Routing Module Layouts
@NgModule({
    imports: [
        BrowserModule, AppRoutingModule, BsDropdownModule.forRoot(),
        AngularMaterialModule,
        CommonModule,
        HttpClientModule,
        BrowserAnimationsModule,
        TabsModule.forRoot(),
        ModalModule.forRoot(),
        ChartsModule,
        MdSelectDataModule,
        SuperadminModule,
        FormsModule,
        ReactiveFormsModule,
        LocalStorageModule.withConfig({prefix: 'mdselect', storageType: 'localStorage'}),
        ReCaptchaModule,
        NgbModalModule.forRoot(),
        CalendarModule.forRoot(),
        AlertModule.forRoot(),
        MatDatepickerModule,
        MatNativeDateModule,
        LoadingModule,
        RlTagInputModule,
        NgxPaginationModule,
        Ng4LoadingSpinnerModule.forRoot(),
        BootstrapModalModule.forRoot({ container: document.body }),
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'danger' // set defaults here
        })
    ],
    declarations: [
        AppComponent,
        FilterPipe,
        FullLayoutComponent,
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        LoginComponent,
        ForgotPasswordComponent,
        SignupComponent,
        ProvidersComponent,
        UploadFormComponent,
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        RegisterComponent,
        DoctorsComponent,
        AddDoctorComponent,
        SchedulesComponent,
        AddScheduleComponent,
        EditScheduleComponent,
        DoctorProfileComponent,
        ScheduleComponent,
        NotificationsComponent,
        ScrollableDirective,
        InvitationsComponent,
        SettingComponent,
        TimeAgoPipe,
        KeysPipe
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        StateService,
        AngularFireAuthProvider,
        AngularFireDatabaseProvider,
        UploadService,
        LocationService,
        ToggleService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts